import Joi from '@hapi/joi';

import { LanguageInfo } from 'types';

import validate from './validate';

interface FormValues {
  name: string;
  [languageCode: string]: string | number | undefined;
}

export const baseSchema = Joi.object<FormValues>({
  id: Joi.number().optional().allow(),
  name: Joi.string().required().messages({
    'string.empty': 'REQUIRED_FIELD',
  }),
});

export const createSchema = (translationLanguages: LanguageInfo[] = []) => {
  let schema = baseSchema;

  // Add validation for each translation language
  translationLanguages.forEach((lang) => {
    schema = schema.keys({
      [lang.code]: Joi.string().required().messages({
        'string.empty': 'REQUIRED_FIELD',
      }),
    });
  });

  return schema;
};

export default (value: FormValues, translationLanguages: LanguageInfo[] = []) => {
  return validate(createSchema(translationLanguages), value, {
    allowUnknown: false,
    context: {},
  });
};
